import './App.css';
import './Checkout';
import Checkout from './Checkout';
import { PaymentProvider } from './components/PaymentContext';

function App() {
  return (
    <PaymentProvider><Checkout></Checkout></PaymentProvider>
  );
}

export default App;
